import moment from "moment";
import { globals, page as pageIndex } from "../../globals";
import { logOut } from "./auth";
import { formatDate } from "./formatDate";
import {
  GET_CLIENTS_FAILURE,
  GET_CLIENT_SUBJECT_INFO_FAILURE,
  GET_GROUPING_FAILURE,
  GET_SUBJECTS_FAILURE,
  POST_CLIENT_SUBJECT_TAG_FAILURE,
  POST_CLIENT_SUBJECT_TAG_SUCCESS,
} from "./groupings";
import { populateSortAndSearchParams } from "./helpers";
import { showModal } from "./modal";
import {
  addInitialValue,
  clearHistory,
  deleteInitialValueAt,
  saveInitialValues,
} from "./undo";
import { UPDATE_DATA, actionHandler } from "./updateData";

// ------------------------------------
// Constants
// ------------------------------------
export const LOCAL_TRACK_INT_OPEN_RECORD_START =
  "LOCAL_TRACK_INT_OPEN_RECORD_START";
export const REFRESH_LOCAL_TRACK_RECORDS = "REFRESH_LOCAL_TRACK_RECORDS";
export const UPDATE_LOCAL_TRACK_REVIEW_DATA = "UPDATE_LOCAL_TRACK_REVIEW_DATA";
export const GET_LOCAL_TRACK_QUERIES_LIST_START =
  "GET_LOCAL_TRACK_QUERIES_LIST_START";
export const GET_LOCAL_TRACK_INT_QUERY_DATA_START =
  "GET_LOCAL_TRACK_INT_QUERY_DATA_START";
export const GET_LOCAL_TRACK_INT_QUERY_DATA_SUCCESS =
  "GET_LOCAL_TRACK_INT_QUERY_DATA_SUCCESS";
export const GET_LOCAL_TRACK_INT_QUERY_DATA_FAILURE =
  "GET_LOCAL_TRACK_INT_QUERY_DATA_FAILURE";
export const GET_LOCAL_TRACK_TEAM_REVIEW_DATA_START =
  "GET_LOCAL_TRACK_TEAM_REVIEW_DATA_START";
export const GET_LOCAL_TRACK_TEAM_REVIEW_DATA_SUCCESS =
  "GET_LOCAL_TRACK_TEAM_REVIEW_DATA_SUCCESS";
export const GET_LOCAL_TRACK_TEAM_REVIEW_DATA_FAILURE =
  "GET_LOCAL_TRACK_TEAM_REVIEW_DATA_FAILURE";
export const SET_LOCAL_TRACK_TEAMS_REVIEW_DATA_START =
  "SET_LOCAL_TRACK_TEAMS_REVIEW_DATA_START";
export const SET_LOCAL_TRACK_TEAMS_REVIEW_DATA_SUCCESS =
  "SET_LOCAL_TRACK_TEAMS_REVIEW_DATA_SUCCESS";
export const SET_LOCAL_TRACK_TEAMS_REVIEW_DATA_FAILURE =
  "SET_LOCAL_TRACK_TEAMS_REVIEW_DATA_FAILURE";
export const POST_LOCAL_TRACK_DATA_START = "POST_LOCAL_TRACK_DATA_START";
export const POST_LOCAL_TRACK_DATA_SUCCESS = "POST_LOCAL_TRACK_DATA_SUCCESS";
export const POST_LOCAL_TRACK_DATA_FAILURE = "POST_LOCAL_TRACK_DATA_FAILURE";
export const PUT_LOCAL_INFO_START = "PUT_LOCAL_INFO_START";
export const PUT_LOCAL_INFO_SUCCESS = "PUT_LOCAL_INFO_SUCCESS";
export const PUT_LOCAL_INFO_FAILURE = "PUT_LOCAL_INFO_FAILURE";
export const PUT_CLIENT_ACTION_START = "PUT_CLIENT_ACTION_START";
export const PUT_CLIENT_ACTION_SUCCESS = "PUT_CLIENT_ACTION_SUCCESS";
export const PUT_CLIENT_ACTION_FAILURE = "PUT_CLIENT_ACTION_FAILURE";
export const PUT_CLIENT_ACTION_COMMENT_START =
  "PUT_CLIENT_ACTION_COMMENT_START";
export const PUT_CLIENT_ACTION_COMMENT_SUCCESS =
  "PUT_CLIENT_ACTION_COMMENT_SUCCESS";
export const PUT_CLIENT_ACTION_COMMENT_FAILURE =
  "PUT_CLIENT_ACTION_COMMENT_FAILURE";
export const UPDATE_LOCAL_URLS = "UPDATE_LOCAL_URLS";
export const GET_LOCAL_TRACK_BASE_START = "GET_LOCAL_TRACK_BASE_START";
export const GET_LOCAL_TRACK_BASE_SUCCESS = "GET_LOCAL_TRACK_BASE_SUCCESS";
export const GET_LOCAL_TRACK_BASE_FAILURE = "GET_LOCAL_TRACK_BASE_FAILURE";
export const GET_LOCAL_TRACK_IDS_START = "GET_LOCAL_TRACK_IDS_START";
export const GET_LOCAL_TRACK_IDS_SUCCESS = "GET_LOCAL_TRACK_IDS_SUCCESS";
export const GET_LOCAL_TRACK_IDS_FAILURE = "GET_LOCAL_TRACK_IDS_FAILURE";
export const GET_LOCAL_TRACK_KEYWORDS_START = "GET_LOCAL_TRACK_KEYWORDS_START";
export const GET_LOCAL_TRACK_KEYWORDS_SUCCESS =
  "GET_LOCAL_TRACK_KEYWORDS_SUCCESS";
export const GET_LOCAL_TRACK_KEYWORDS_FAILURE =
  "GET_LOCAL_TRACK_KEYWORDS_FAILURE";
export const GET_LOCAL_TRACK_CLIENT_SUBJECTS_START =
  "GET_LOCAL_TRACK_CLIENT_SUBJECTS_START";
export const GET_LOCAL_TRACK_CLIENT_SUBJECTS_SUCCESS =
  "GET_LOCAL_TRACK_CLIENT_SUBJECTS_SUCCESS";
export const GET_LOCAL_TRACK_CLIENT_SUBJECTS_FAILURE =
  "GET_LOCAL_TRACK_CLIENT_SUBJECTS_FAILURE";
export const GET_LOCAL_TRACK_LOCAL_TYPE_START =
  "GET_LOCAL_TRACK_LOCAL_TYPE_START";
export const GET_LOCAL_TRACK_LOCAL_TYPE_SUCCESS =
  "GET_LOCAL_TRACK_LOCAL_TYPE_SUCCESS";
export const GET_LOCAL_TRACK_LOCAL_TYPE_FAILURE =
  "GET_LOCAL_TRACK_LOCAL_TYPE_FAILURE";
export const GET_LOCAL_TRACK_LOAD_OPTIONS_START =
  "GET_LOCAL_TRACK_LOAD_OPTIONS_START";
export const GET_LOCAL_TRACK_LOAD_OPTIONS_FAILURE =
  "GET_LOCAL_TRACK_LOAD_OPTIONS_FAILURE";
export const CLEAR_LOCAL_TRACK_FIELD_FOR_NO_RESULTS =
  "CLEAR_LOCAL_TRACK_FIELD_FOR_NO_RESULTS";
export const RETURN_LOCAL_TRACK_INITIAL_STATE =
  "RETURN_LOCAL_TRACK_INITIAL_STATE";
export const OPEN_LOCAL_TRACK_RECORD_SUCCESS =
  "OPEN_LOCAL_TRACK_RECORD_SUCCESS";
export const SET_LOCAL_TRACK_ID_REVIEWED_START =
  "SET_LOCAL_TRACK_ID_REVIEWED_START";
export const SET_LOCAL_TRACK_ID_REVIEWED_FAILURE =
  "SET_LOCAL_TRACK_ID_REVIEWED_FAILURE";
export const SET_LOCAL_TRACK_ID_REVIEWED_SUCCESS =
  "SET_LOCAL_TRACK_ID_REVIEWED_SUCCESS";
export const GET_LOCAL_TRACK_HIGHLIGHTED_DOC_START =
  "GET_LOCAL_TRACK_HIGHLIGHTED_DOC_START";
export const GET_LOCAL_TRACK_HIGHLIGHTED_DOC_FAILURE =
  "GET_LOCAL_TRACK_HIGHLIGHTED_DOC_FAILURE";
export const GET_LOCAL_TRACK_HIGHLIGHTED_DOC_SUCCESS =
  "GET_LOCAL_TRACK_HIGHLIGHTED_DOC_SUCCESS";
export const GET_LOCAL_TRACK_INITIAL_DATA_START =
  "GET_LOCAL_TRACK_INITIAL_DATA_START";
export const GET_LOCAL_TRACK_INITIAL_DATA_COMPLETE =
  "GET_LOCAL_TRACK_INITIAL_DATA_COMPLETE";
export const GET_QC_KEYWORD_MISSING_START = "GET_QC_KEYWORD_MISSING_START";
export const GET_QC_KEYWORD_MISSING_SUCCESS = "GET_QC_KEYWORD_MISSING_SUCCESS";
export const GET_QC_KEYWORD_MISSING_FAILURE = "GET_QC_KEYWORD_MISSING_FAILURE";
export const GET_QC_KEYWORD_REVIEW_START = "GET_QC_KEYWORD_REVIEW_START";
export const GET_QC_KEYWORD_REVIEW_SUCCESS = "GET_QC_KEYWORD_REVIEW_SUCCESS";
export const GET_QC_KEYWORD_REVIEW_FAILURE = "GET_QC_KEYWORD_REVIEW_FAILURE";
export const GET_LOCAL_TRACK_SUBJECT_GROUP_LIST_START =
  "GET_LOCAL_TRACK_SUBJECT_GROUP_LIST_START";
export const GET_LOCAL_TRACK_SUBJECT_GROUP_LIST_FAILURE =
  "GET_LOCAL_TRACK_SUBJECT_GROUP_LIST_FAILURE";
export const GET_LOCAL_TRACK_SUBJECT_GROUP_LIST_SUCCESS =
  "GET_LOCAL_TRACK_SUBJECT_GROUP_LIST_SUCCESS";
export const SET_QC_KEYWORD_REVIEW_START = "SET_QC_KEYWORD_REVIEW_START";
export const SET_QC_KEYWORD_REVIEW_FAILURE = "SET_QC_KEYWORD_REVIEW_FAILURE";
export const SET_QC_KEYWORD_REVIEW_SUCCESS = "SET_QC_KEYWORD_REVIEW_SUCCESS";
export const FLIP_LOCAL_RECORD_LOCK_LOAD_DATE =
  "FLIP_LOCAL_RECORD_LOCK_LOAD_DATE";
export const DELETE_LOCAL_DOC_START = "DELETE_LOCAL_DOC_START";
export const DELETE_LOCAL_DOC_SUCCESS = "DELETE_LOCAL_DOC_SUCCESS";
export const DELETE_LOCAL_DOC_FAILURE = "DELETE_LOCAL_DOC_FAILURE";
export const DELETE_LOCAL_RECORD_START = "DELETE_LOCAL_RECORD_START";
export const DELETE_LOCAL_RECORD_SUCCESS = "DELETE_LOCAL_RECORD_SUCCESS";
export const DELETE_LOCAL_RECORD_FAILURE = "DELETE_LOCAL_RECORD_FAILURE";
export const DELETE_LOCAL_HISTORY_START = "DELETE_LOCAL_HISTORY_START";
export const DELETE_LOCAL_HISTORY_SUCCESS = "DELETE_LOCAL_HISTORY_SUCCESS";
export const DELETE_LOCAL_HISTORY_FAILURE = "DELETE_LOCAL_HISTORY_FAILURE";
export const DELETE_LOCAL_URL_START = "DELETE_LOCAL_URL_START";
export const ADD_NEW_LOCAL_URL_RECORD = "ADD_NEW_LOCAL_URL_RECORD";
export const ADD_NEW_HISTORY_ACTION_RECORD = "ADD_NEW_HISTORY_ACTION_RECORD";
export const DELETE_LOCAL_URL_SUCCESS = "DELETE_LOCAL_URL_SUCCESS";
export const DELETE_LOCAL_URL_FAILURE = "DELETE_LOCAL_URL_FAILURE";
export const ADD_LOCAL_DOC_START = "ADD_LOCAL_DOC_START";
export const ADD_LOCAL_DOC_SUCCESS = "ADD_LOCAL_DOC_SUCCESS";
export const ADD_LOCAL_DOC_FAILURE = "ADD_LOCAL_DOC_FAILURE";
export const ADD_LOCAL_HISTORY_ACTION_START = "ADD_LOCAL_HISTORY_ACTION_START";
export const ADD_LOCAL_HISTORY_ACTION_SUCCESS =
  "ADD_LOCAL_HISTORY_ACTION_SUCCESS";
export const ADD_LOCAL_HISTORY_ACTION_FAILURE =
  "ADD_LOCAL_HISTORY_ACTION_FAILURE";
export const GET_LOCALITIES_START = "GET_LOCALITIES_START";
export const GET_LOCALITIES_FAILURE = "GET_LOCALITIES_FAILURE";
export const GET_LOCALITIES_SUCCESS = "GET_LOCALITIES_SUCCESS";
export const DELETE_LOCAL_CLIENT_SUBJECT_TAG_START =
  "DELETE_LOCAL_CLIENT_SUBJECT_TAG_START";
export const DELETE_LOCAL_CLIENT_SUBJECT_TAG_SUCCESS =
  "DELETE_LOCAL_CLIENT_SUBJECT_TAG_SUCCESS";
export const DELETE_LOCAL_CLIENT_SUBJECT_TAG_FAILURE =
  "DELETE_LOCAL_CLIENT_SUBJECT_TAG_FAILURE";
export const PUT_LOCAL_CLIENT_SUBJECT_TAG_START =
  "PUT_LOCAL_CLIENT_SUBJECT_TAG_START";
export const PUT_LOCAL_CLIENT_SUBJECT_TAG_SUCCESS =
  "PUT_LOCAL_CLIENT_SUBJECT_TAG_SUCCESS";
export const PUT_LOCAL_CLIENT_SUBJECT_TAG_FAILURE =
  "PUT_LOCAL_CLIENT_SUBJECT_TAG_FAILURE";
export const PUT_LOCAL_TRACK_INT_URL_START = "PUT_LOCAL_TRACK_INT_URL_START";
export const PUT_LOCAL_TRACK_INT_URL_SUCCESS =
  "PUT_LOCAL_TRACK_INT_URL_SUCCESS";
export const PUT_LOCAL_TRACK_INT_URL_FAILURE =
  "PUT_LOCAL_TRACK_INT_URL_FAILURE";
export const POST_LOCAL_TRACK_INT_URL_START = "POST_LOCAL_TRACK_INT_URL_START";
export const POST_LOCAL_TRACK_INT_URL_SUCCESS =
  "POST_LOCAL_TRACK_INT_URL_SUCCESS";
export const POST_LOCAL_TRACK_INT_URL_FAILURE =
  "POST_LOCAL_TRACK_INT_URL_FAILURE";
export const UPDATE_SUBSCRIBE_DATE_ALL_START =
  "UPDATE_SUBSCRIBE_DATE_ALL_START";
export const UPDATE_SUBSCRIBE_DATE_ALL_SUCCESS =
  "UPDATE_SUBSCRIBE_DATE_ALL_SUCCESS";
export const UPDATE_SUBSCRIBE_DATE_ALL_FAILURE =
  "UPDATE_SUBSCRIBE_DATE_ALL_FAILURE";
export const GET_LOCAL_HISTORY_START = "GET_LOCAL_HISTORY_START";
export const GET_LOCAL_HISTORY_FAILURE = "GET_LOCAL_HISTORY_FAILURE";
export const GET_LOCAL_HISTORY_SUCCESS = "GET_LOCAL_HISTORY_SUCCESS";
export const PUT_LOCAL_HISTORY_START = "PUT_LOCAL_HISTORY_START";
export const PUT_LOCAL_HISTORY_SUCCESS = "PUT_LOCAL_HISTORY_SUCCESS";
export const PUT_LOCAL_HISTORY_FAILURE = "PUT_LOCAL_HISTORY_FAILURE";
export const GET_LOCAL_HISTORY_LOG_START = "GET_LOCAL_HISTORY_LOG_START";
export const GET_LOCAL_HISTORY_LOG_SUCCESS = "GET_LOCAL_HISTORY_LOG_SUCCESS";
export const GET_LOCAL_HISTORY_LOG_FAILURE = "GET_LOCAL_HISTORY_LOG_FAILURE";
export const ADD_LOCAL_MANAGMENT_COMMENT_START =
  "ADD_LOCAL_MANAGMENT_COMMENT_START";
export const ADD_LOCAL_MANAGMENT_COMMENT_SUCCESS =
  "ADD_LOCAL_MANAGMENT_COMMENT_SUCCESS";
export const ADD_LOCAL_MANAGMENT_COMMENT_FAILURE =
  "ADD_LOCAL_MANAGMENT_COMMENT_FAILURE";
export const ADD_SENDALERT_HISTORY_LOG_START =
  "ADD_SENDALERT_HISTORY_LOG_START";
export const ADD_SENDALERT_HISTORY_LOG_SUCCESS =
  "ADD_SENDALERT_HISTORY_LOG_SUCCESS";
export const ADD_SENDALERT_HISTORY_LOG_FAILURE =
  "ADD_SENDALERT_HISTORY_LOG_FAILURE";
export const PUT_LOCAL_MANAGEMENT_COMMENT_START =
  "PUT_LOCAL_MANAGEMENT_COMMENT_START";
export const PUT_LOCAL_MANAGEMENT_COMMENT_SUCCESS =
  "PUT_LOCAL_MANAGEMENT_COMMENT_SUCCESS";
export const PUT_LOCAL_MANAGEMENT_COMMENT_FAILURE =
  "PUT_LOCAL_MANAGEMENT_COMMENT_FAILURE";
export const GET_LOCAL_TAG_COMPARISON_START = "GET_LOCAL_TAG_COMPARISON_START";
export const GET_LOCAL_TAG_COMPARISON_FAILURE =
  "GET_LOCAL_TAG_COMPARISON_FAILURE";
export const GET_LOCAL_TAG_COMPARISON_SUCCESS =
  "GET_LOCAL_TAG_COMPARISON_SUCCESS";
export const PUT_COMPANION_BILL_REVIEW_START =
  "PUT_COMPANION_BILL_REVIEW_START";
export const PUT_COMPANION_BILL_REVIEW_SUCCESS =
  "PUT_COMPANION_BILL_REVIEW_SUCCESS";
export const PUT_COMPANION_BILL_REVIEW_FAILURE =
  "PUT_COMPANION_BILL_REVIEW_FAILURE";
export const POST_LOCAL_START = "POST_LOCAL_START";
export const POST_LOCAL_SUCCESS = "POST_LOCAL_SUCCESS";
export const POST_LOCAL_FAILURE = "POST_LOCAL_FAILURE";
export const UPLOAD_DOCUMENT_START = "UPLOAD_DOCUMENT_START";
export const UPLOAD_DOCUMENT_SUCCESS = "UPLOAD_DOCUMENT_SUCCESS";
export const UPLOAD_DOCUMENT_FAILURE = "UPLOAD_DOCUMENT_FAILURE";

const headers = {
  "Content-Type": "application/json",
};

export function getLocalTrackInternalInitialState() {
  return initialState;
}

function formatDateShort(date) {
  return date && date !== "" ? moment(date).format("MM/DD/YYYY") : "";
}

function matchReviewRows(rows) {
  return rows.map((item) => {
    return {
      textValues: {
        team: item.Team || "",
        assignedBy: item.AssignedBy || "",
        assignedDate: formatDate(item.AssignedDate),
        reviewedBy: item.ReviewedBy || "",
        reviewedDate: formatDate(item.ReviewedDate),
        type: item.FlagTypeDesc,
        flag: String(item.FlagType),
      },
      isReviewed: item.ReviewedBy !== null,
    };
  });
}

function matchBaseRecordInfo(info) {
  const recordInfo = {
    textValues: {
      country: info.Country || "",
      contact: info.ContactInformation || "",
      notes: info.Notes || "",
      localId: info.LocalId,
      loadDate: formatDate(info.LoadDate),
      oldLoadDate: formatDate(info.LoadDate),
      summary: info.Summary || "",
      year: info.Year || "",
      lastUpdateToRecord: formatDate(info.LastUpdateTS),
      lastUpdateUserId: info.LastUpdateId || "",
      state: info.State || "",
      deleted: info.Deleted || false,
      title: info.Title || "",
      remarks: info.Remarks || "",
    },
    radio: {
      locality: info.Locality || "",
      active: info.Active || false,
    },
  };

  return matchSubHistoryData(recordInfo, info);
}

function matchRecordInfo(info, baseRecordInfo) {
  const recordCreated = formatDate(info.CreateDate);
  const reviewers = info.Reviewers || [];

  const recordInfo = combineRecordInfo(
    baseRecordInfo,
    recordCreated,
    reviewers
  );

  return matchSubHistoryData(recordInfo, info);
}

function combineRecordInfo(baseRecordInfo, recordCreated, reviewers) {
  return {
    ...baseRecordInfo,
    textValues: {
      ...baseRecordInfo.textValues,
      recordCreated: recordCreated,
      reviewers: reviewers,
    },
  };
}

function matchSubHistoryData(recordInfo, info) {
  return {
    ...recordInfo,
    textValues: {
      ...recordInfo.textValues,
      supplementalHistory: info.SupplementalHistory || "",
      historyRemarks: info.HistoryRemarks || "",
      historyRemarksUpdated: formatDate(info.RemarksUpdated),
      effectiveModifiedDate: formatDate(info.EffectiveModifiedDate),
      effectiveDate: formatDateShort(info.EffectiveDate),
      publicLawNumber: info.PublicActNo || "",
    },
  };
}

function matchDocuments(documents) {
  return documents
    ? documents.map((doc) => {
        return {
          url: doc.Url,
          description: doc.Description,
          urlType: doc.Type,
          id: doc.Id,
        };
      })
    : [];
}

function matchHistoryActionOptions(historyActionOptions) {
  return historyActionOptions
    ? historyActionOptions.map((historyActionOption) => {
        return matchHistoryActionOption(historyActionOption);
      })
    : [];
}

function matchHistoryActionOption(historyActionOption) {
  return {
    value: historyActionOption[0],
    label: historyActionOption[0],
    activeFlag: historyActionOption[1],
  };
}

function matchHistoryActions(historyActions) {
  return historyActions
    ? historyActions.map((historyAction) => {
        return matchHistoryAction(historyAction);
      })
    : [];
}

function matchHistoryAction(historyAction) {
  return {
    textValues: {
      CreateDate: formatDate(
        historyAction && historyAction.CreateDate
          ? historyAction.CreateDate
          : new Date()
      ),
      CreateUser:
        historyAction && historyAction.CreateUser
          ? historyAction.CreateUser
          : "",
      HistoryDate: formatDate(
        historyAction && historyAction.HistoryDate
          ? historyAction.HistoryDate
          : new Date()
      ),
      LocalHistoryId:
        historyAction && historyAction.LocalHistoryId
          ? historyAction.LocalHistoryId
          : -1,
      LocalId:
        historyAction && historyAction.LocalId ? historyAction.LocalId : -1,
      NewRecord: historyAction ? false : true,
    },
    radio: {
      HistoryAction:
        historyAction && historyAction.HistoryAction
          ? historyAction.HistoryAction
          : "",
    },
  };
}

function matchLocalUrls(localUrls) {
  return localUrls
    ? localUrls.map((localUrl) => {
        return matchLocalUrl(localUrl);
      })
    : [];
}

function matchLocalUrl(localUrl = null) {
  const newLocalUrl = {
    textValues: {
      Url: localUrl && localUrl.Url ? localUrl.Url : "",
      Description: localUrl && localUrl.Description ? localUrl.Description : "",
      Page: "",
      Id: localUrl && localUrl.Id ? localUrl.Id : -1,
      LocalId: localUrl && localUrl.RecId ? localUrl.RecId : -1,
      LinkUrl: localUrl && localUrl.LinkUrl ? localUrl.LinkUrl : "",
      SSUrl: localUrl && localUrl.SSUrl ? localUrl.SSUrl : "",
      MaintainOnSS:
        !localUrl ? true : localUrl.MaintainOnSS,
      UrlBad: !localUrl ? false : localUrl.UrlBad,
      UrlCheckedDate: formatDate(
        localUrl && localUrl.UrlCheckedDate
          ? localUrl.UrlCheckedDate
          : new Date()
      ),
      SortOrder: localUrl && localUrl.SortOrder ? localUrl.SortOrder : 0,
      NewRecord: localUrl ? false : true,
    },
  };

  return newLocalUrl;
}

function matchManagementComments(managementComments) {
  return managementComments
    ? managementComments.map((managementComment) => {
        return matchManagementComment(managementComment);
      })
    : [];
}

function matchManagementComment(managementComment) {
  return {
    textValues: {
      Id: managementComment.Id || "",
      RecordId: managementComment.RecordId || "",
      DataType: managementComment.DataType || "",
      DateAdded: formatDate(managementComment.DateAdded),
      AssignedBy: managementComment.AssignedBy || "",
      Comment: managementComment.Comment || "",
      Response: managementComment.Response || "",
      ResponseBy: managementComment.ResponseBy || "",
      ResponseDate: formatDate(managementComment.ResponseDate),
      MissedBill: !!managementComment.MissedBill,
      LateTagRequest: !!managementComment.LateTagRequest,
      CommentComplete: !!managementComment.CommentComplete,
      Reviewed: !!managementComment.Reviewed,
    },
    radio: {
      TeamAssigned: managementComment.TeamAssigned || "",
    },
  };
}

function matchClientSubjectTags(clientSubjectTags) {
  return clientSubjectTags
    ? clientSubjectTags.map((clientSubjectTag) => {
        return matchClientSubjectTag(clientSubjectTag);
      })
    : [];
}

function matchClientSubjectTag(clientSubjectTag) {
  return {
    SubjectId: clientSubjectTag.SubjectId,
    Client: clientSubjectTag.Client,
    Subject: clientSubjectTag.Subject,
    DataType: clientSubjectTag.DataType,
    RecordId: clientSubjectTag.RecordId,
    SubscribeDate: formatDate(clientSubjectTag.SubscribeDate),
    CreateUser: clientSubjectTag.CreateUser,
    OriginalCreateDate: formatDate(clientSubjectTag.OriginalCreateDate),
    LastUpdateDate: formatDate(clientSubjectTag.LastUpdateDate),
    LastUpdateUser: clientSubjectTag.LastUpdateUser,
    IssueId: clientSubjectTag.IssueId,
    EmailAlerts: clientSubjectTag.EmailAlerts,
    Deleted: clientSubjectTag.Deleted,
    Autoload: clientSubjectTag.Autoload,
    DeletedByAnalyst: clientSubjectTag.DeletedByAnalyst,
    CanEdit: clientSubjectTag.CanEdit,
  };
}

function matchStandardRemarks(standardRemarks) {
  return standardRemarks
    ? standardRemarks.map((standardRemark) => {
        return {
          label: standardRemark,
          value: standardRemark,
        };
      })
    : [];
}

function matchLocalities(localities) {
  return localities
    ? localities.map((locality) => {
        return {
          label: locality.Locality,
          value: locality.Locality,
          activeFlag: locality.DeleteDate ? false : true,
        };
      })
    : [];
}

function matchClientActions(info) {
  return info.ClientActions
    ? info.ClientActions.map((action) => {
        return matchClientAction(action);
      })
    : [];
}

function matchClientAction(action) {
  return {
    textValues: {
      stsReviewer: action.StateScapeCheckedBy || "",
      reviewDate: formatDate(action.StateScapeCheckedDate),
      stsComment: action.StateScapeComments || "",
      client: action.Client || "",
      loginId: action.LogonId || "",
      action: action.Action || "",
      changedDate: formatDate(action.ChangeDate),
      userEmail: action.Email || "",
      actionDetails: action.ActionDetail || "",
      clientComment: action.ClientComments || "",
      clientActionId: action.ClientActionId || "",
    },
  };
}

function matchIderInfo(info) {
  return {
    textValues: {
      ider: info.IDer || "",
      iderReviewed: info.IDerReviewed || "",
      iderReviewedDate: formatDate(info.IDerReviewedDate),
    },
  };
}

function matchKeywordHits(hits) {
  return hits.map((hit) => {
    return {
      textValues: {
        team: hit.Team || "",
        client: hit.Client || "",
        grouping: hit.Subject || "",
        keyword: hit.Keyword || "",
        hits: hit.Hits,
        foundDate: formatDate(hit.FoundDate),
        changeDate: formatDate(hit.ChangeDate),
        oldHits: hit.OldHits,
        keywordId: hit.KeywordId,
        taggingInstructions: hit.GroupTaggingInstructions || "",
        description: hit.GroupDescription || "",
        overview: hit.GroupOverview || "",
        boolPhrase: hit.BoolPhrase,
        groupingId: hit.GroupingId,
      },
    };
  });
}

function matchClientSubjects(clients) {
  return clients.map((client) => {
    return {
      textValues: {
        deleted: client.DeleteIt || false,
        client: client.ClientName || "",
        clientDescription: client.ClientDescription || "",
        subject: client.Subject || "",
        subjectDescription: client.SubjectDescription || "",
        changeDate: formatDate(client.CreateDate),
        user: client.CreateUserId || "",
      },
    };
  });
}

function matchBooleansToSelectionList(values) {
  return {
    selected: Object.keys(values).filter(
      (key) => values[key] && typeof values[key] == "boolean"
    ),
  };
}

function matchQCKeywordReview(keywordsReview) {
  return keywordsReview.map((keywordReview) => {
    return {
      textValues: {
        reviewDate: formatDate(keywordReview.ReviewDate),
        reviewer: keywordReview.Reviewer || "",
        client: keywordReview.Client || "",
        subject: keywordReview.Subject || "",
      },
    };
  });
}

function matchQCKeywordMissing(keywordsMissing) {
  return keywordsMissing.map((keywordMissing) => {
    return {
      textValues: {
        client: keywordMissing.Client || "",
        subject: keywordMissing.Subject || "",
        team: keywordMissing.Team || "",
        id: keywordMissing.Id || "",
        reviewed: keywordMissing.Reviewed || "",
      },
    };
  });
}

function matchHistoryLog(historyLog) {
  return historyLog.map((log) => {
    return {
      HistoryDate: log.CreateDate,
      User: log.UserName,
      HistoryAction: log.Activity,
    };
  });
}

// ------------------------------------
// Actions
// ------------------------------------

const getReviewData = (localId) => {
  return (dispatch) =>
    dispatch(getLocalTrackBase(localId, dispatch)).then(() => {
      Promise.all([
        dispatch(getLocalKeywords(localId)),
        dispatch(getLocalHistoryLog(localId)),
      ]);
    });
};

export function openReviewRecord(localId) {
  return (dispatch) => {
    dispatch({ type: LOCAL_TRACK_INT_OPEN_RECORD_START });
    dispatch(getReviewData(localId, dispatch)).finally(() => {
      dispatch({
        type: OPEN_LOCAL_TRACK_RECORD_SUCCESS,
        payload: { localId },
      });
    });
  };
}

const getInitialData = () => {
  return (dispatch) =>
    Promise.all([
      dispatch(getLocalTrackInternalQueryData()),
      dispatch(getLocalities()),
    ]);
};

export function loadInitialData() {
  return (dispatch) =>
    Promise.all([
      dispatch({ type: GET_LOCAL_TRACK_INITIAL_DATA_START }),
      dispatch(getInitialData()).finally(() => {
        dispatch({ type: GET_LOCAL_TRACK_INITIAL_DATA_COMPLETE });
      }),
    ]);
}

export function getLocalTrackInternalQueryData() {
  return (dispatch) => {
    dispatch({ type: GET_LOCAL_TRACK_INT_QUERY_DATA_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/LocalTrackIntQuery`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_LOCAL_TRACK_INT_QUERY_DATA_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LOCAL_TRACK_INT_QUERY_DATA_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: GET_LOCAL_TRACK_INT_QUERY_DATA_FAILURE,
          json: err.message,
        });
      });
  };
}

export function postLocalTrackInternal(localUrlsParameters) {
  return (dispatch) => {
    dispatch({ type: POST_LOCAL_TRACK_DATA_START });
    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify(localUrlsParameters),
    };
    return fetch(`${globals.apiUrl}/LocalTrackIntQuery`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: POST_LOCAL_TRACK_DATA_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: POST_LOCAL_TRACK_DATA_SUCCESS,
            payload: {
              json,
            },
          });
          if (json.length > 0) {
            dispatch(openReviewRecord(json[0]));
          } else {
            dispatch(showModal("No-results"));
            dispatch(clearFormFields());
          }
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: POST_LOCAL_TRACK_DATA_FAILURE,
          json: err.message,
        });
      });
  };
}

export function postLocalTrack(localTrackInfo) {
  return (dispatch) => {
    dispatch({ type: POST_LOCAL_START });
    const options = {
      method: "Post",
      credentials: "include",
      headers,
      body: JSON.stringify(localTrackInfo),
    };
    return fetch(`${globals.apiUrl}/localtrackint`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: POST_LOCAL_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: POST_LOCAL_SUCCESS,
            payload: {
              baseRecordInfo: matchBaseRecordInfo(json),
            },
          });

          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: POST_LOCAL_FAILURE,
          json: err.message,
        });
      });
  };
}

export function putLocalTrackInfo(localTrackInfo) {
  return (dispatch) => {
    dispatch({ type: PUT_LOCAL_INFO_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: JSON.stringify(localTrackInfo),
    };
    return fetch(`${globals.apiUrl}/localtrackint`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_LOCAL_INFO_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_LOCAL_INFO_SUCCESS,
            payload: {
              baseRecordInfo: matchBaseRecordInfo(json),
            },
          });

          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_LOCAL_INFO_FAILURE,
          json: err.message,
        });
      });
  };
}

export function putClientAction(clientActionId) {
  return (dispatch) => {
    dispatch({ type: PUT_CLIENT_ACTION_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: JSON.stringify({ ClientActionId: clientActionId }),
    };
    return fetch(`${globals.apiUrl}/clientaction`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_CLIENT_ACTION_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_CLIENT_ACTION_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_CLIENT_ACTION_FAILURE,
          json: err.message,
        });
      });
  };
}

export function putClientActionComment(clientAction) {
  return (dispatch) => {
    dispatch({ type: PUT_CLIENT_ACTION_COMMENT_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: JSON.stringify(clientAction),
    };
    return fetch(`${globals.apiUrl}/clientactioncomment`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_CLIENT_ACTION_COMMENT_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_CLIENT_ACTION_COMMENT_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_CLIENT_ACTION_COMMENT_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getLocalTeamReview(id) {
  return (dispatch) => {
    dispatch({ type: GET_LOCAL_TRACK_TEAM_REVIEW_DATA_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RawFile/TeamReview/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_LOCAL_TRACK_TEAM_REVIEW_DATA_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LOCAL_TRACK_TEAM_REVIEW_DATA_SUCCESS,
            payload: {
              json,
              id,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_LOCAL_TRACK_TEAM_REVIEW_DATA_FAILURE,
          json: err.message,
        });
      });
  };
}

export function postLocalTeamsReview(id, teams, reviewed, flagType) {
  return (dispatch) => {
    dispatch({ type: SET_LOCAL_TRACK_TEAMS_REVIEW_DATA_START });
    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({
        localId: id,
        team: teams[0],
        reviewed: reviewed,
        flagType: flagType,
      }),
    };
    return fetch(`${globals.apiUrl}/RawFile/TeamReview`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: SET_LOCAL_TRACK_TEAMS_REVIEW_DATA_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: SET_LOCAL_TRACK_TEAMS_REVIEW_DATA_SUCCESS,
            payload: {
              json,
              id,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: SET_LOCAL_TRACK_TEAMS_REVIEW_DATA_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getLocalTrackBase(id) {
  return (dispatch) => {
    dispatch({ type: GET_LOCAL_TRACK_BASE_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/v2/LocalTrackInt/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_LOCAL_TRACK_BASE_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          const recordInfo = matchRecordInfo(json, matchBaseRecordInfo(json));
          const clientActions = matchClientActions(json);
          const standardRemarks = matchStandardRemarks(json.StandardRemarks);
          const documents = matchDocuments(json.Documents);
          const clientSubjectTags = matchClientSubjectTags(json.ClientSubjects);
          const managementComments = matchManagementComments(
            json.ManagementComments
          );
          const historyActions = matchHistoryActions(json.HistoryActions).sort(
            (a, b) => b.HistoryDate - a.HistoryDate
          );

          const historyActionOptions = matchHistoryActionOptions(
            json.HistoryActionOptions
          );
          const localUrls = matchLocalUrls(json.LocalUrls).sort(
            (a, b) => a.textValues.SortOrder - b.textValues.SortOrder
          );

          dispatch({
            type: GET_LOCAL_TRACK_BASE_SUCCESS,
            payload: {
              recordInfo,
              clientActions,
              documents,
              clientSubjectTags,
              managementComments,
              standardRemarks,
              historyActions,
              historyActionOptions,
              localUrls,
            },
          });
          dispatch(clearHistory(pageIndex.localTrackInternal));
          dispatch(
            saveInitialValues(pageIndex.localTrackInternal, {
              recordInfo,
              clientActions,
              documents,
              clientSubjectTags,
              managementComments,
              standardRemarks,
              historyActions,
              localUrls,
            })
          );

          return recordInfo;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_LOCAL_TRACK_BASE_FAILURE, json: err.message });
      });
  };
}

export function moveURL(urlIndex, localUrls, direction) {
  return (dispatch) => {
    const { localUrlCurrent, localUrlNext } = moveUrlOrder(
      urlIndex,
      localUrls,
      direction
    );

    dispatch(
      updateLocalTrackIntURL(localUrlCurrent.textValues, urlIndex - direction)
    );
    dispatch(updateLocalTrackIntURL(localUrlNext.textValues, urlIndex));
  };
}

export function getLocalTrackIds(locality, meetingDate) {
  return (dispatch) => {
    dispatch({ type: GET_LOCAL_TRACK_IDS_START });
    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/LocalTrackInt/`);

    const params = {
      locality,
      meetingDate,
    };

    if (Object.keys(params)) {
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          url.searchParams.append(key, params[key]);
        }
      });
    }

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_LOCAL_TRACK_IDS_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_LOCAL_TRACK_IDS_FAILURE, json: err.message });
      });
  };
}

export function postIdReviewed(id) {
  return (dispatch) => {
    dispatch({ type: SET_LOCAL_TRACK_ID_REVIEWED_START });
    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: id,
    };
    return fetch(`${globals.apiUrl}/RawFile/IdReview`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: SET_LOCAL_TRACK_ID_REVIEWED_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: SET_LOCAL_TRACK_ID_REVIEWED_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: SET_LOCAL_TRACK_ID_REVIEWED_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getLocalKeywords(id) {
  return (dispatch) => {
    dispatch({ type: GET_LOCAL_TRACK_KEYWORDS_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RawFile/GetKeywords/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_LOCAL_TRACK_KEYWORDS_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LOCAL_TRACK_KEYWORDS_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_LOCAL_TRACK_KEYWORDS_FAILURE, json: err.message });
      });
  };
}

export function getQCKeywordReview(id) {
  return (dispatch) => {
    dispatch({ type: GET_QC_KEYWORD_REVIEW_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RawFile/GetQCKeywordReview/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_QC_KEYWORD_REVIEW_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_QC_KEYWORD_REVIEW_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_QC_KEYWORD_REVIEW_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getQCKeywordMissing(id) {
  return (dispatch) => {
    dispatch({ type: GET_QC_KEYWORD_MISSING_START });
    const options = {
      method: "GET",
      credentials: "include",
    };
    return fetch(`${globals.apiUrl}/RawFile/GetQCKeywordMissing/${id}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_QC_KEYWORD_MISSING_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_QC_KEYWORD_MISSING_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_QC_KEYWORD_MISSING_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getSubjectGroupList(client, subject) {
  return (dispatch) => {
    dispatch({ type: GET_LOCAL_TRACK_SUBJECT_GROUP_LIST_START });

    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/SubjectGroupList`);

    const params = {
      client,
      subject,
      searchType: "Local",
    };

    if (Object.keys(params)) {
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          url.searchParams.append(key, params[key]);
        }
      });
    }

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_LOCAL_TRACK_SUBJECT_GROUP_LIST_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LOCAL_TRACK_SUBJECT_GROUP_LIST_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_LOCAL_TRACK_SUBJECT_GROUP_LIST_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getHighlightedDocument(teams, keywords, path) {
  return (dispatch) => {
    dispatch({ type: GET_LOCAL_TRACK_HIGHLIGHTED_DOC_START });

    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/KeywordHits`);

    const params = {
      docpath: path,
      service: "local",
    };

    if (Object.keys(params)) {
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          url.searchParams.append(key, params[key]);
        }
      });
    }

    if (teams && teams.length != 0) {
      teams.forEach((team) => {
        if (String(team).length > 0) {
          url.searchParams.append("teamId", team);
        }
      });
    }

    if (keywords && keywords.length != 0) {
      keywords.forEach((keyword) =>
        url.searchParams.append("keywordId", keyword)
      );
    }

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.url;
        } else if (response.status === 302) {
          return response.url;
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_LOCAL_TRACK_HIGHLIGHTED_DOC_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((url) => {
        if (url) {
          dispatch({
            type: GET_LOCAL_TRACK_HIGHLIGHTED_DOC_SUCCESS,
            payload: {
              url,
            },
          });
          return url;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_LOCAL_TRACK_HIGHLIGHTED_DOC_FAILURE,
          json: "Highlighting document: " + err.message,
        });
        dispatch(showModal("Error"));
      });
  };
}

export function postQCKeywordReview(rawfileId, team, customName) {
  return (dispatch) => {
    dispatch({ type: SET_QC_KEYWORD_REVIEW_START });

    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({ rawfileId, team, customName }),
    };

    return fetch(`${globals.apiUrl}/RawFile/QCKeywordReview`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: SET_QC_KEYWORD_REVIEW_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((success) => {
        return success;
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: SET_QC_KEYWORD_REVIEW_FAILURE, json: err.message });
      });
  };
}

export function deleteLocalDocument(docId) {
  return (dispatch) => {
    dispatch({ type: DELETE_LOCAL_DOC_START });

    const options = {
      method: "DELETE",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/localdoc/${docId}`);

    return fetch(url, options)
      .then((response) => {
        if (response.status === 204 || response.status === 200) {
          dispatch({
            type: DELETE_LOCAL_DOC_SUCCESS,
            payload: {
              docId,
            },
          });
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 409 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: DELETE_LOCAL_DOC_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: DELETE_LOCAL_DOC_FAILURE, json: err.message });
      });
  };
}

export function flipLockLoadDate() {
  return (dispatch) => {
    dispatch({ type: FLIP_LOCAL_RECORD_LOCK_LOAD_DATE });
  };
}

export function deleteLocalRecord(localId) {
  return (dispatch) => {
    dispatch({ type: DELETE_LOCAL_RECORD_START });

    const options = {
      method: "DELETE",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/localtrackint/${localId}`);

    return fetch(url, options)
      .then((response) => {
        if (response.status === 204 || response.status === 200) {
          dispatch({
            type: DELETE_LOCAL_RECORD_SUCCESS,
            payload: {
              localId,
            },
          });
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 409 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: DELETE_LOCAL_RECORD_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: DELETE_LOCAL_RECORD_FAILURE, json: err.message });
      });
  };
}

export function addLocalDocument(document) {
  return (dispatch) => {
    dispatch({ type: ADD_LOCAL_DOC_START });

    const { type, url, description, linkedRecord } = document;

    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({
        Type: type,
        Url: url,
        Description: description,
        RawFileId: linkedRecord,
      }),
    };

    return fetch(`${globals.apiUrl}/localdoc`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400 || response.status === 409) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: ADD_LOCAL_DOC_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: ADD_LOCAL_DOC_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: ADD_LOCAL_DOC_FAILURE,
          json: err.message,
        });
      });
  };
}

export function addLocalTrackIntURL(localTrackUrl, arrayIndex) {
  return (dispatch) => {
    dispatch({ type: POST_LOCAL_TRACK_INT_URL_START });

    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({
        recId: localTrackUrl.LocalId,
        description: localTrackUrl.Description,
        url: localTrackUrl.Url,
        maintainOnSS: localTrackUrl.MaintainOnSS,
        page: localTrackUrl.Page,
      }),
    };

    return fetch(`${globals.apiUrl}/LocalTrackIntUrl`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 409 ||
          response.status === 404 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: POST_LOCAL_TRACK_INT_URL_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: POST_LOCAL_TRACK_INT_URL_SUCCESS,
            payload: {
              json,
              arrayIndex,
            },
          });

          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: POST_LOCAL_TRACK_INT_URL_FAILURE,
          json: err.message,
        });
      });
  };
}

export function updateLocalTrackIntURL(localTrackUrl, arrayIndex) {
  return (dispatch) => {
    dispatch({ type: PUT_LOCAL_TRACK_INT_URL_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: [JSON.stringify(localTrackUrl)],
    };
    return fetch(`${globals.apiUrl}/LocalTrackIntUrl`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 500 ||
          response.status === 404
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_LOCAL_TRACK_INT_URL_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_LOCAL_TRACK_INT_URL_SUCCESS,
            payload: {
              json,
              arrayIndex,
            },
          });

          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_LOCAL_TRACK_INT_URL_FAILURE,
          json: err.message,
        });
      });
  };
}

export function addActionRecordToHistoryActions() {
  return (dispatch) => {
    dispatch({ type: ADD_NEW_HISTORY_ACTION_RECORD });
    dispatch(
      addInitialValue(
        pageIndex.localTrackInternal,
        "historyActions",
        matchHistoryAction()
      )
    );
  };
}

export function addLocalUrlRecordToURls() {
  return (dispatch) => {
    dispatch({ type: ADD_NEW_LOCAL_URL_RECORD });
    dispatch(
      addInitialValue(
        pageIndex.localTrackInternal,
        "localUrls",
        matchLocalUrl()
      )
    );
  };
}

export function deleteLocalUrl(localUrlId, recordInfo, arrayIndex) {
  return (dispatch) => {
    dispatch({ type: DELETE_LOCAL_URL_START });

    if (localUrlId === -1) {
      dispatch(
        deleteInitialValueAt(
          {
            page: pageIndex.localTrackInternal,
            field: "localUrls",
          },
          arrayIndex
        )
      );

      return dispatch({
        type: DELETE_LOCAL_URL_SUCCESS,
        payload: {
          localUrlId,
          recordInfo,
          arrayIndex,
        },
      });
    }

    const options = {
      method: "DELETE",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/LocalTrackIntUrl/${localUrlId}`);

    return fetch(url, options)
      .then((response) => {
        if (response.status === 204 || response.status === 200) {
          dispatch({
            type: DELETE_LOCAL_URL_SUCCESS,
            payload: {
              localUrlId,
              recordInfo,
              arrayIndex,
            },
          });
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 409 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: DELETE_LOCAL_URL_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: DELETE_LOCAL_URL_FAILURE, json: err.message });
      });
  };
}

export function deleteHistoryAction(localHistoryId, recordInfo, arrayIndex) {
  return (dispatch) => {
    dispatch({ type: DELETE_LOCAL_HISTORY_START });

    if (localHistoryId === -1) {
      dispatch(
        deleteInitialValueAt(
          {
            page: pageIndex.localTrackInternal,
            field: "historyActions",
          },
          arrayIndex
        )
      );

      dispatch({
        type: DELETE_LOCAL_HISTORY_SUCCESS,
        payload: {
          localHistoryId,
          recordInfo,
          arrayIndex,
        },
      });

      return;
    }

    const options = {
      method: "DELETE",
      credentials: "include",
    };

    const url = new URL(
      `${globals.apiUrl}/localtrackinthistory/${localHistoryId}`
    );

    return fetch(url, options)
      .then((response) => {
        if (response.status === 204 || response.status === 200) {
          dispatch({
            type: DELETE_LOCAL_HISTORY_SUCCESS,
            payload: {
              localHistoryId,
              arrayIndex,
            },
          });
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 409 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: DELETE_LOCAL_HISTORY_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: DELETE_LOCAL_HISTORY_FAILURE, json: err.message });
      });
  };
}

export function addHistoryAction(historyAction, arrayIndex) {
  return (dispatch) => {
    dispatch({ type: ADD_LOCAL_HISTORY_ACTION_START });

    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify(historyAction),
    };

    return fetch(`${globals.apiUrl}/localtrackinthistory`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 409 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: ADD_LOCAL_HISTORY_ACTION_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: ADD_LOCAL_HISTORY_ACTION_SUCCESS,
            payload: {
              json,
              arrayIndex,
            },
          });

          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: ADD_LOCAL_HISTORY_ACTION_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getLocalities() {
  return (dispatch) => {
    dispatch({ type: GET_LOCALITIES_START });

    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(
      `${globals.apiUrl}/localreview?actiondatetype=0&includedeleted=true`
    );

    try {
      return fetch(url, options)
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            dispatch(logOut());
          } else if (response.status === 400) {
            response.text().then((text) => {
              if (text) {
                dispatch({
                  type: GET_LOCALITIES_FAILURE,
                  json: text,
                });
                dispatch(showModal("Error"));
              }
            });
          }
        })
        .then((json) => {
          if (json) {
            dispatch({
              type: GET_LOCALITIES_SUCCESS,
              payload: {
                json,
              },
            });

            return json;
          }
        })
        .catch((err) => {
          console.log(err);
          dispatch({
            type: GET_LOCALITIES_FAILURE,
            json: "Retrieving Localities" + err.message,
          });
          dispatch(showModal("Error"));
        });
    } catch {
      (error) => {
        dispatch({
          type: GET_LOCALITIES_FAILURE,
          json: error,
        });
      };
    }
  };
}

export function deleteClientSubjectTag(subjectId) {
  return (dispatch) => {
    dispatch({ type: DELETE_LOCAL_CLIENT_SUBJECT_TAG_START });

    const options = {
      method: "DELETE",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/clientSubjectTag/${subjectId}`);

    return fetch(url, options)
      .then((response) => {
        if (response.status === 204 || response.status === 200) {
          dispatch({
            type: DELETE_LOCAL_CLIENT_SUBJECT_TAG_SUCCESS,
            payload: {
              subjectId,
            },
          });
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (
          response.status === 400 ||
          response.status === 404 ||
          response.status === 409 ||
          response.status === 500
        ) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: DELETE_LOCAL_CLIENT_SUBJECT_TAG_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: DELETE_LOCAL_CLIENT_SUBJECT_TAG_FAILURE,
          json: err.message,
        });
      });
  };
}

export function putClientSubjectTag(clientSubjectTag) {
  return (dispatch) => {
    dispatch({ type: PUT_LOCAL_CLIENT_SUBJECT_TAG_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: [JSON.stringify(clientSubjectTag)],
    };
    return fetch(`${globals.apiUrl}/clientSubjectTag`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_LOCAL_CLIENT_SUBJECT_TAG_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_LOCAL_CLIENT_SUBJECT_TAG_SUCCESS,
            payload: {
              json,
            },
          });

          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_LOCAL_CLIENT_SUBJECT_TAG_FAILURE,
          json: err.message,
        });
      });
  };
}

export function updateSubscribeDateForAll(recordId, dataType, subscribeDate) {
  return (dispatch) => {
    dispatch({ type: UPDATE_SUBSCRIBE_DATE_ALL_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: JSON.stringify({
        recordId,
        dataType,
        subscribeDate,
      }),
    };
    return fetch(`${globals.apiUrl}/ClientSubjectSubscription`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: UPDATE_SUBSCRIBE_DATE_ALL_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: UPDATE_SUBSCRIBE_DATE_ALL_SUCCESS,
            payload: {
              json,
            },
          });
          return true;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: UPDATE_SUBSCRIBE_DATE_ALL_FAILURE,
          json: err.message,
        });
      });
  };
}

export function putLocalHistory(historyData) {
  return (dispatch) => {
    dispatch({ type: PUT_LOCAL_HISTORY_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: JSON.stringify(historyData),
    };

    return fetch(`${globals.apiUrl}/localtrackinthistory`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400 || response.status === 409) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_LOCAL_HISTORY_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_LOCAL_HISTORY_SUCCESS,
            payload: {
              json,
            },
          });

          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_LOCAL_HISTORY_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getLocalHistoryLog(id) {
  return (dispatch) => {
    dispatch({ type: GET_LOCAL_HISTORY_LOG_START });
    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/HistoryLog`);

    const params = {
      entityType: "localid",
      entityId: id,
    };

    if (Object.keys(params)) {
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          url.searchParams.append(key, params[key]);
        }
      });
    }

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_LOCAL_HISTORY_LOG_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LOCAL_HISTORY_LOG_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_LOCAL_HISTORY_LOG_FAILURE, json: err.message });
      });
  };
}

export function addManagementComment(
  recordId,
  team,
  comment,
  lateTagRequest,
  missedBill
) {
  return (dispatch) => {
    dispatch({ type: ADD_LOCAL_MANAGMENT_COMMENT_START });

    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({
        recordId,
        DataType: "local",
        TeamAssigned: team,
        comment,
        lateTagRequest,
        missedBill,
      }),
    };

    return fetch(`${globals.apiUrl}/managementcomments`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400 || response.status === 409) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: ADD_LOCAL_MANAGMENT_COMMENT_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: ADD_LOCAL_MANAGMENT_COMMENT_SUCCESS,
            payload: {
              json,
            },
          });

          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: ADD_LOCAL_MANAGMENT_COMMENT_FAILURE,
          json: err.message,
        });
      });
  };
}

export function sendAlertHistoryLog(entityId, activityDescription) {
  return (dispatch) => {
    dispatch({ type: ADD_SENDALERT_HISTORY_LOG_START });

    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify({
        entityType: "LocalId",
        workItemLocation: "LocalTrack",
        entityId,
        activityDescription,
      }),
    };

    return fetch(`${globals.apiUrl}/HistoryLog`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400 || response.status === 409) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: ADD_SENDALERT_HISTORY_LOG_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: ADD_SENDALERT_HISTORY_LOG_SUCCESS,
            payload: {
              json,
            },
          });

          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: ADD_SENDALERT_HISTORY_LOG_FAILURE,
          json: err.message,
        });
      });
  };
}

export function updateManagementComment(managementComment) {
  return (dispatch) => {
    dispatch({ type: PUT_LOCAL_MANAGEMENT_COMMENT_START });
    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: JSON.stringify(managementComment),
    };

    return fetch(`${globals.apiUrl}/managementcomments`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400 || response.status === 409) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_LOCAL_MANAGEMENT_COMMENT_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_LOCAL_MANAGEMENT_COMMENT_SUCCESS,
            payload: {
              json,
            },
          });

          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_LOCAL_MANAGEMENT_COMMENT_FAILURE,
          json: err.message,
        });
      });
  };
}

export function getLocalTagComparison(primaryLocalId, companionLocalId) {
  return (dispatch) => {
    dispatch({ type: GET_LOCAL_TAG_COMPARISON_START });

    const options = {
      method: "GET",
      credentials: "include",
    };

    const url = new URL(`${globals.apiUrl}/LocalTagComparison`);

    const params = {
      primaryLocalId,
      companionLocalId,
    };

    if (Object.keys(params)) {
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          url.searchParams.append(key, params[key]);
        }
      });
    }

    return fetch(url, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_LOCAL_TAG_COMPARISON_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LOCAL_TAG_COMPARISON_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_LOCAL_TAG_COMPARISON_FAILURE,
          json: err.message,
        });
      });
  };
}

export function putCompanionBillReview(localId, team, reviewed) {
  return (dispatch) => {
    dispatch({ type: PUT_COMPANION_BILL_REVIEW_START });

    const options = {
      method: "Put",
      credentials: "include",
      headers,
      body: JSON.stringify({
        LocalId: localId,
        Reviews: [{ TeamGroupId: team, Reviewed: reviewed }],
      }),
    };

    return fetch(`${globals.apiUrl}/CompanionBillReview`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: PUT_COMPANION_BILL_REVIEW_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: PUT_COMPANION_BILL_REVIEW_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: PUT_COMPANION_BILL_REVIEW_FAILURE,
          json: err.message,
        });
      });
  };
}

export function uploadUrl(
  recordId,
  uploadFile,
  recordType,
  description,
  page,
  arrayIndex
) {
  return (dispatch) => {
    dispatch({ type: UPLOAD_DOCUMENT_START });

    const formData = new FormData();

    formData.append("Description", description);
    formData.append("RecId", recordId);
    formData.append("RecType", recordType);
    formData.append("UploadedFile", uploadFile);
    formData.append("PageNumber", page);

    const options = {
      method: "POST",
      credentials: "include",
      body: formData,
    };

    return fetch(`${globals.apiUrl}/document`, options)
      .then((response) => {
        if (response.redirected) {
          return { type: "url", url: response.url };
        }

        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400 || response.status === 409) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: UPLOAD_DOCUMENT_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: POST_LOCAL_TRACK_INT_URL_SUCCESS,
            payload: {
              json,
              arrayIndex,
            },
          });

          return json;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: UPLOAD_DOCUMENT_FAILURE,
          json: "Uploading document: " + err.message,
        });
        dispatch(showModal("Error"));
      });
  };
}

export function clearFormFields() {
  return {
    type: CLEAR_LOCAL_TRACK_FIELD_FOR_NO_RESULTS,
  };
}

export function returnInitialState() {
  return {
    type: RETURN_LOCAL_TRACK_INITIAL_STATE,
  };
}

function moveUrlOrder(urlIndex, localUrls, direction) {
  const localUrlCurrent = {
    ...localUrls[urlIndex],
    textValues: {
      ...localUrls[urlIndex].textValues,
      SortOrder: localUrls[urlIndex].textValues.SortOrder - direction,
    },
  };

  const localUrlNext = {
    ...localUrls[urlIndex - direction],
    textValues: {
      ...localUrls[urlIndex - direction].textValues,
      SortOrder:
        localUrls[urlIndex - direction].textValues.SortOrder + direction,
    },
  };

  const newLocalUrls = Object.assign([], localUrls, {
    [urlIndex]: localUrlCurrent,
    [urlIndex - direction]: localUrlNext,
  }).sort((a, b) => a.textValues.SortOrder - b.textValues.SortOrder);

  return { localUrlCurrent, localUrlNext, newLocalUrls };
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_DATA]: (state, action) =>
    action.location.page !== pageIndex.localTrackInternal
      ? state
      : actionHandler(state, action),
  [RETURN_LOCAL_TRACK_INITIAL_STATE]: () => {
    return {
      ...initialState,
    };
  },
  [GET_LOCAL_TRACK_INT_QUERY_DATA_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_LOCAL_TRACK_INT_QUERY_DATA_SUCCESS]: (state, action) => {
    const { json } = action.payload;
    return {
      ...state,
      renderData: {
        ...state.renderData,
        queriesWithParameters: json,
        queries: json.map((item) => {
          return {
            value: item.QueryId,
            label: item.QueryName,
          };
        }),
      },
    };
  },
  [UPDATE_LOCAL_URLS]: (state, action) => {
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          localUrls: action.newLocalUrls,
        },
      },
    };
  },
  [POST_LOCAL_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [POST_LOCAL_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [POST_LOCAL_SUCCESS]: (state) => {
    // const baseRecordInfo = action.payload.baseRecordInfo;
    // const recordCreated =
    //   state.formDataValue.LOTI.recordInfo.textValues.recordCreated;
    // const reviewers = state.formDataValue.LOTI.recordInfo.textValues.reviewers;

    // const recordInfo = combineRecordInfo(
    //   baseRecordInfo,
    //   recordCreated,
    //   reviewers
    // );

    // return {
    //   ...state,
    //   formDataValue: {
    //     ...state.formDataValue,
    //     LOTI: {
    //       ...state.formDataValue.LOTI,
    //       recordInfo,
    //     },
    //   },
    // };
    return {
      ...state,
    };
  },
  [PUT_LOCAL_INFO_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [PUT_LOCAL_INFO_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [PUT_LOCAL_INFO_SUCCESS]: (state, action) => {
    const baseRecordInfo = action.payload.baseRecordInfo;
    const recordCreated =
      state.formDataValue.LOTI.recordInfo.textValues.recordCreated;
    const reviewers = state.formDataValue.LOTI.recordInfo.textValues.reviewers;

    const recordInfo = combineRecordInfo(
      baseRecordInfo,
      recordCreated,
      reviewers
    );

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          recordInfo,
        },
      },
    };
  },
  [PUT_LOCAL_HISTORY_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [PUT_LOCAL_HISTORY_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [PUT_LOCAL_HISTORY_SUCCESS]: (state, action) => {
    const newHistoryAction = action.payload.json;

    const historyActionIndex =
      state.formDataValue.LOTI.historyActions.findIndex(
        (historyAction) =>
          historyAction.textValues.LocalHistoryId ===
          newHistoryAction.LocalHistoryId
      );

    const newState = {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          historyActions: Object.assign(
            [],
            state.formDataValue.LOTI.historyActions,
            {
              [historyActionIndex]: matchHistoryAction(newHistoryAction),
            }
          ),
        },
      },
    };

    return newState;
  },
  [PUT_LOCAL_MANAGEMENT_COMMENT_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [PUT_LOCAL_MANAGEMENT_COMMENT_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [PUT_LOCAL_MANAGEMENT_COMMENT_SUCCESS]: (state, action) => {
    const newManagementComment = action.payload.json;

    const commentIndex = state.formDataValue.LOTI.managementComments.findIndex(
      (managementComment) =>
        managementComment.textValues.Id === newManagementComment.Id
    );

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          managementComments: Object.assign(
            [],
            state.formDataValue.LOTI.managementComments,
            {
              [commentIndex]: matchManagementComment(newManagementComment),
            }
          ),
        },
      },
    };
  },
  [ADD_SENDALERT_HISTORY_LOG_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [PUT_LOCAL_CLIENT_SUBJECT_TAG_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [UPDATE_SUBSCRIBE_DATE_ALL_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [UPDATE_SUBSCRIBE_DATE_ALL_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [UPDATE_SUBSCRIBE_DATE_ALL_SUCCESS]: (state, action) => {
    const clientSubjectTags = matchClientSubjectTags(action.payload.json);

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          clientSubjectTags,
        },
      },
    };
  },
  [PUT_LOCAL_CLIENT_SUBJECT_TAG_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [PUT_LOCAL_CLIENT_SUBJECT_TAG_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [PUT_LOCAL_CLIENT_SUBJECT_TAG_SUCCESS]: (state, action) => {
    const newCientSubjectTag = action.payload.json;

    const tageIndex = state.formDataValue.LOTI.clientSubjectTags.findIndex(
      (clientSubjectTag) =>
        clientSubjectTag.SubjectId === newCientSubjectTag.SubjectId
    );

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          clientSubjectTags: Object.assign(
            [],
            state.formDataValue.LOTI.clientSubjectTags,
            {
              [tageIndex]: matchClientSubjectTag(newCientSubjectTag),
            }
          ),
        },
      },
    };
  },
  [PUT_CLIENT_ACTION_COMMENT_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [PUT_CLIENT_ACTION_COMMENT_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [PUT_CLIENT_ACTION_COMMENT_SUCCESS]: (state, action) => {
    return clientAtionSuccess(action, state);
  },
  [PUT_CLIENT_ACTION_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [PUT_CLIENT_ACTION_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [PUT_CLIENT_ACTION_SUCCESS]: (state, action) => {
    return clientAtionSuccess(action, state);
  },
  [PUT_COMPANION_BILL_REVIEW_START]: (state) => {
    return {
      ...state,
      //isFetchingData: true,
    };
  },
  [PUT_COMPANION_BILL_REVIEW_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [PUT_COMPANION_BILL_REVIEW_SUCCESS]: (state, action) => {
    const companionBill = action.payload.json;

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          companionReviewedTeams: matchBooleansToSelectionList({
            1: companionBill.CompanionReviewedTeamGroup1,
            2: companionBill.CompanionReviewedTeamGroup2,
            3: companionBill.CompanionReviewedTeamGroup3,
          }),
        },
      },
    };
  },
  [POST_LOCAL_TRACK_DATA_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [POST_LOCAL_TRACK_DATA_SUCCESS]: (state, action) => {
    const queryRecords = action.payload.json;
    return {
      ...state,
      renderData: {
        ...state.renderData,
        queryRecords,
      },
    };
  },
  [POST_LOCAL_TRACK_DATA_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [GET_LOCAL_TRACK_TEAM_REVIEW_DATA_START]: (state) => {
    return {
      ...state,
    };
  },
  [GET_LOCAL_TRACK_TEAM_REVIEW_DATA_SUCCESS]: (state, action) => {
    const recordsData = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          reviewRecords: matchReviewRows(recordsData),
        },
      },
    };
  },
  [GET_LOCAL_TRACK_TEAM_REVIEW_DATA_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [SET_LOCAL_TRACK_TEAMS_REVIEW_DATA_START]: (state) => {
    return {
      ...state,
    };
  },
  [SET_LOCAL_TRACK_TEAMS_REVIEW_DATA_SUCCESS]: (state, action) => {
    const recordsData = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          reviewRecords: matchReviewRows(recordsData),
        },
      },
    };
  },
  [SET_LOCAL_TRACK_TEAMS_REVIEW_DATA_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [DELETE_LOCAL_DOC_START]: (state) => {
    return {
      ...state,
    };
  },
  [DELETE_LOCAL_DOC_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [DELETE_LOCAL_DOC_SUCCESS]: (state, action) => {
    const { docId } = action.payload;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          documents: state.formDataValue.LOTI.documents.filter(
            (doc) => doc.id !== docId
          ),
        },
      },
    };
  },
  [ADD_NEW_HISTORY_ACTION_RECORD]: (state) => {
    const newHistoryAction = [
      matchHistoryAction(),
      ...state.formDataValue.LOTI.historyActions,
    ];
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          historyActions: newHistoryAction,
        },
      },
    };
  },
  [ADD_NEW_LOCAL_URL_RECORD]: (state) => {
    const newLocalUrls = [
      matchLocalUrl(),
      ...state.formDataValue.LOTI.localUrls,
    ];
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          localUrls: newLocalUrls,
        },
      },
    };
  },
  [DELETE_LOCAL_URL_START]: (state) => {
    return {
      ...state,
    };
  },
  [DELETE_LOCAL_URL_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [DELETE_LOCAL_URL_SUCCESS]: (state, action) => {
    const { arrayIndex } = action.payload;
    const newLocalUrls = [...state.formDataValue.LOTI.localUrls];
    newLocalUrls.splice(arrayIndex, 1);

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          localUrls: newLocalUrls,
        },
      },
    };
  },
  [DELETE_LOCAL_HISTORY_START]: (state) => {
    return {
      ...state,
    };
  },
  [DELETE_LOCAL_HISTORY_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [DELETE_LOCAL_HISTORY_SUCCESS]: (state, action) => {
    const { arrayIndex } = action.payload;
    const newHistoryActions = [...state.formDataValue.LOTI.historyActions];
    newHistoryActions.splice(arrayIndex, 1);

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          historyActions: newHistoryActions,
        },
      },
    };
  },
  [FLIP_LOCAL_RECORD_LOCK_LOAD_DATE]: (state) => {
    return {
      ...state,
      lockLoadDate: !state.lockLoadDate,
    };
  },
  [DELETE_LOCAL_RECORD_START]: (state) => {
    return {
      ...state,
    };
  },
  [DELETE_LOCAL_RECORD_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [DELETE_LOCAL_RECORD_SUCCESS]: (state, action) => {
    const { localId } = action.payload;
    const queryRecords = state.renderData.queryRecords.filter(
      (id) => id !== localId
    );

    return {
      ...state,
      renderData: {
        ...state.renderData,
        queryRecords,
      },
    };
  },
  [DELETE_LOCAL_CLIENT_SUBJECT_TAG_START]: (state) => {
    return {
      ...state,
    };
  },
  [DELETE_LOCAL_CLIENT_SUBJECT_TAG_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [DELETE_LOCAL_CLIENT_SUBJECT_TAG_SUCCESS]: (state, action) => {
    const { subjectId } = action.payload;
    const newClientSubjectTags = [
      ...state.formDataValue.LOTI.clientSubjectTags,
    ];
    const changingClientSubjectTag = newClientSubjectTags.find(
      (clientSubjectTag) => clientSubjectTag.SubjectId === subjectId
    );

    changingClientSubjectTag.Deleted = true;
    changingClientSubjectTag.DeletedByAnalyst = true;

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          clientSubjectTags: newClientSubjectTags,
        },
      },
    };
  },
  [ADD_LOCAL_HISTORY_ACTION_START]: (state) => {
    return {
      ...state,
    };
  },
  [ADD_LOCAL_HISTORY_ACTION_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [ADD_LOCAL_HISTORY_ACTION_SUCCESS]: (state, action) => {
    const { json, arrayIndex } = action.payload;

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          historyActions: Object.values({
            ...state.formDataValue.LOTI.historyActions,
            [arrayIndex]: matchHistoryAction(json),
          }),
        },
      },
    };
  },
  [PUT_LOCAL_TRACK_INT_URL_START]: (state) => {
    return {
      ...state,
      localUrlUpdating: true,
    };
  },
  [PUT_LOCAL_TRACK_INT_URL_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      localUrlUpdating: false,
      isError: true,
    };
  },
  [PUT_LOCAL_TRACK_INT_URL_SUCCESS]: (state, action) => {
    const { json, arrayIndex } = action.payload;

    return {
      ...state,
      localUrlUpdating: false,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          localUrls: Object.values({
            ...state.formDataValue.LOTI.localUrls,
            [arrayIndex]: matchLocalUrl(json),
          }),
        },
      },
    };
  },
  [ADD_LOCAL_DOC_START]: (state) => {
    return {
      ...state,
    };
  },
  [ADD_LOCAL_DOC_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [ADD_LOCAL_DOC_SUCCESS]: (state, action) => {
    const { json } = action.payload;
    const newDocument = matchDocuments([json]);
    const newDocuments = [
      ...state.formDataValue.LOTI.documents,
      ...newDocument,
    ];
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          documents: newDocuments,
        },
      },
    };
  },
  [POST_LOCAL_TRACK_INT_URL_START]: (state) => {
    return {
      ...state,
    };
  },
  [POST_LOCAL_TRACK_INT_URL_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [POST_LOCAL_TRACK_INT_URL_SUCCESS]: (state, action) => {
    const { json, arrayIndex } = action.payload;

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          localUrls: Object.values({
            ...state.formDataValue.LOTI.localUrls,
            [arrayIndex]: matchLocalUrl(json),
          }),
        },
      },
    };
  },
  [ADD_LOCAL_MANAGMENT_COMMENT_START]: (state) => {
    return {
      ...state,
    };
  },
  [ADD_LOCAL_MANAGMENT_COMMENT_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [ADD_LOCAL_MANAGMENT_COMMENT_SUCCESS]: (state, action) => {
    const { json } = action.payload;
    const newManagamentComment = matchManagementComment(json);
    const newManagamentComments = [
      newManagamentComment,
      ...state.formDataValue.LOTI.managementComments,
    ];
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          managementComments: newManagamentComments,
        },
      },
    };
  },
  [GET_LOCAL_TRACK_QUERIES_LIST_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_LOCAL_TRACK_IDS_START]: (state) => {
    return {
      ...state,
    };
  },
  [GET_LOCAL_TRACK_IDS_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [GET_LOCAL_TRACK_BASE_START]: (state) => {
    return {
      ...state,
    };
  },
  [GET_LOCAL_TRACK_BASE_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [GET_LOCAL_TRACK_BASE_SUCCESS]: (state, action) => {
    const clientActions = action.payload.clientActions;
    const recordInfo = action.payload.recordInfo;
    const documents = action.payload.documents;
    const clientSubjectTags = action.payload.clientSubjectTags;
    const managementComments = action.payload.managementComments;
    const standardRemarks = action.payload.standardRemarks;
    const historyActions = action.payload.historyActions;
    const historyActionOptions = action.payload.historyActionOptions;
    const localUrls = action.payload.localUrls;

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          recordInfo,
          clientActions,
          documents,
          clientSubjectTags,
          managementComments,
          standardRemarks,
          historyActions,
          localUrls,
        },
      },
      renderData: {
        ...state.renderData,
        historyActionOptions,
      },
    };
  },
  [GET_LOCAL_TRACK_INITIAL_DATA_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_LOCAL_TRACK_INITIAL_DATA_COMPLETE]: (state) => {
    return {
      ...state,
      isFetchingData: false,
    };
  },
  [LOCAL_TRACK_INT_OPEN_RECORD_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [OPEN_LOCAL_TRACK_RECORD_SUCCESS]: (state, action) => {
    const currentIndex = state.renderData.queryRecords.findIndex(
      (record) => record === action.payload.localId
    );
    return {
      ...state,
      isFetchingData: false,
      lockLoadDate: false,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          currentLocalId: action.payload.localId,
          navigation: {
            ...state.formDataValue.LOTI.navigation,
            textValues: {
              ...state.formDataValue.LOTI.navigation.textValues,
              currentRecord: currentIndex + 1,
            },
          },
        },
      },
    };
  },
  [SET_LOCAL_TRACK_ID_REVIEWED_SUCCESS]: (state, action) => {
    const iderInfo = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          iderReviewedInfo: matchIderInfo(iderInfo),
        },
      },
    };
  },
  [GET_LOCAL_TRACK_KEYWORDS_SUCCESS]: (state, action) => {
    const keywordHits = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          recordKeywordHits: matchKeywordHits(keywordHits),
        },
      },
    };
  },
  [GET_LOCAL_TRACK_CLIENT_SUBJECTS_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [GET_LOCAL_TRACK_CLIENT_SUBJECTS_SUCCESS]: (state, action) => {
    const keywordHits = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          recordClientSubjects: matchClientSubjects(keywordHits),
        },
      },
    };
  },
  [GET_LOCAL_HISTORY_LOG_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [GET_LOCAL_HISTORY_LOG_SUCCESS]: (state, action) => {
    const historyLog = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          textBlocks: {
            ...state.formDataValue.LOTI.textBlocks,
            textValues: {
              ...state.formDataValue.LOTI.textBlocks.textValues,
              log: matchHistoryLog(historyLog),
            },
          },
        },
      },
    };
  },
  [GET_QC_KEYWORD_MISSING_SUCCESS]: (state, action) => {
    const keywordsMissing = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          recordQCKeywordMissing: matchQCKeywordMissing(keywordsMissing),
        },
      },
    };
  },
  [GET_QC_KEYWORD_REVIEW_SUCCESS]: (state, action) => {
    const keywordsReview = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          recordQCKeywordReview: matchQCKeywordReview(keywordsReview),
        },
      },
    };
  },
  [GET_LOCAL_TRACK_HIGHLIGHTED_DOC_START]: (state) => {
    return {
      ...state,
    };
  },
  [GET_LOCAL_TRACK_HIGHLIGHTED_DOC_SUCCESS]: (state) => {
    return {
      ...state,
    };
  },
  [GET_LOCAL_TRACK_HIGHLIGHTED_DOC_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
  [GET_LOCALITIES_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_LOCALITIES_SUCCESS]: (state, action) => {
    const localities = matchLocalities(action.payload.json);

    return {
      ...state,
      renderData: {
        ...state.renderData,
        localities: localities,
      },
    };
  },
  [GET_LOCALITIES_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [GET_LOCAL_HISTORY_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_LOCAL_HISTORY_SUCCESS]: (state, action) => {
    const currentLocalProgress = matchBooleansToSelectionList(
      action.payload.json
    );
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          currentLocalProgress: currentLocalProgress,
        },
      },
    };
  },
  [GET_LOCAL_HISTORY_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [POST_CLIENT_SUBJECT_TAG_SUCCESS]: (state, action) => {
    const clientSubjectTags = matchClientSubjectTags(action.payload.json);

    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          clientSubjectTags: [
            ...clientSubjectTags,
            ...state.formDataValue.LOTI.clientSubjectTags,
          ],
        },
      },
    };
  },
  [POST_CLIENT_SUBJECT_TAG_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [GET_LOCAL_TRACK_SUBJECT_GROUP_LIST_START]: (state) => {
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          clientSubjectGroupings: [],
        },
      },
    };
  },
  [GET_LOCAL_TRACK_SUBJECT_GROUP_LIST_SUCCESS]: (state, action) => {
    const groupingsList = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          clientSubjectGroupings: groupingsList,
        },
      },
    };
  },
  [GET_LOCAL_TRACK_SUBJECT_GROUP_LIST_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [GET_LOCAL_TAG_COMPARISON_START]: (state) => {
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          companionPrimaryTags: {},
        },
      },
    };
  },
  [GET_LOCAL_TAG_COMPARISON_SUCCESS]: (state, action) => {
    const companionPrimaryTags = action.payload.json;
    return {
      ...state,
      formDataValue: {
        ...state.formDataValue,
        LOTI: {
          ...state.formDataValue.LOTI,
          companionPrimaryTags: companionPrimaryTags,
        },
      },
    };
  },
  [GET_LOCAL_TAG_COMPARISON_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [SET_QC_KEYWORD_REVIEW_START]: (state) => {
    return {
      ...state,
    };
  },
  [SET_QC_KEYWORD_REVIEW_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [GET_CLIENTS_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [GET_CLIENT_SUBJECT_INFO_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [GET_GROUPING_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [GET_SUBJECTS_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
    };
  },
  [UPLOAD_DOCUMENT_START]: (state) => {
    return {
      ...state,
    };
  },
  [UPLOAD_DOCUMENT_SUCCESS]: (state) => {
    return {
      ...state,
      isFetchingData: false,
    };
  },
  [UPLOAD_DOCUMENT_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isFetchingData: false,
      isError: true,
    };
  },
  [CLEAR_LOCAL_TRACK_FIELD_FOR_NO_RESULTS]: (state) => {
    const query = state.renderData.queriesWithParameters.find(
      (query) => query.QueryId == state.formDataValue.LOTI.queryLine.radio.query
    );

    const {
      parametersSectionSelectables,
      sortParameters,
      sortFields,
      sortDirections,
      filterFields,
    } = populateSortAndSearchParams(query);

    return {
      ...initialState,
      disableEditing: true,
      renderData: {
        ...initialState.renderData,
        localities: state.renderData.localities,
        historyActionOptions: state.renderData.historyActionOptions,
        queriesWithParameters: state.renderData.queriesWithParameters,
        queries: state.renderData.queries,
        allRegions: state.renderData.allRegions,
        regions: state.renderData.regions,
        regionsList: state.renderData.regionsList,
        localDocTypes: state.renderData.localDocTypes,
        nonDeletableDocTypes: state.renderData.nonDeletableDocTypes,
      },
      formDataValue: {
        LOTI: {
          ...initialState.formDataValue.LOTI,
          queryLine: {
            ...state.formDataValue.LOTI.queryLine,
          },
          parametersSection: {
            ...state.formDataValue.LOTI.parametersSection,
            radio: parametersSectionSelectables,
          },
          sortParameters: {
            radio: sortParameters,
            fields: sortFields,
          },
          sortDirections: {
            radio: sortDirections,
          },
          filterParameters: {
            fields: filterFields,
          },
        },
      },
    };
  },
};
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  errorCode: "",
  isFetchingData: false,
  lockLoadDate: false,
  renderData: {
    queryRecords: [],
    queryProperties: [],
    currentRecord: {},
    recordIndex: 0,
    localities: [],
    historyActionOptions: [],
  },
  formDataValue: {
    LOTI: {
      settingsLine: {
        radio: {
          autoAdvance: true,
          autoUrl: false,
          extraInfoExpanded: false,
          clientActionsExpanded: false,
        },
      },
      queryLine: {
        radio: {
          query: "Select Query",
        },
        textValues: {
          keywordSearch: "",
        },
        selected: [],
      },
      parametersSection: {
        textValues: {},
        dateTime: {},
        radio: [],
      },
      sortParameters: {
        radio: [],
        fields: [],
      },
      sortDirections: {
        radio: [],
      },
      filterParameters: {
        fields: [],
      },
      navigation: {
        textValues: {
          currentRecord: "1",
        },
      },
      currentLocalProgress: matchBooleansToSelectionList([]),
      reviewRecords: matchReviewRows([]),
      recordInfo: matchRecordInfo(
        {},
        matchBaseRecordInfo({ LoadDate: new Date("1/1/1901") })
      ),
      iderReviewedInfo: matchIderInfo({}),
      recordKeywordHits: matchKeywordHits([]),
      recordClientSubjects: matchClientSubjects([]),
      recordQCKeywordMissing: matchQCKeywordMissing([]),
      recordQCKeywordReview: matchQCKeywordReview([]),
      documents: matchDocuments([]),
      clientActions: matchClientActions([]),
      historyActions: matchHistoryActions([]),
      localUrls: matchLocalUrls([]),
      clientSubjectTags: [],
      clientSubjectGroupings: [],
      managementComments: [],
      standardRemarks: [],
      otherDocs: {
        0: {
          textValues: {
            urlIdDocs: "",
            urlDescription: "",
          },
          radio: {
            docsType: "versions",
          },
        },
      },
      clients: {
        selected: [],
      },
      notLoadedClients: {
        selected: [],
      },
      history: {
        textValues: {
          history: "",
        },
      },
      textBlocks: {
        textValues: {
          log: [],
        },
      },
    },
  },
};

function clientAtionSuccess(action, state) {
  const updatedClientAction = action.payload.json;
  const clientActionIndex = state.formDataValue.LOTI.clientActions.findIndex(
    (clientAction) =>
      clientAction.textValues.clientActionId ===
      updatedClientAction.ClientActionId
  );

  return {
    ...state,
    formDataValue: {
      ...state.formDataValue,
      LOTI: {
        ...state.formDataValue.LOTI,
        clientActions: Object.values({
          ...state.formDataValue.LOTI.clientActions,
          [clientActionIndex]: matchClientAction(updatedClientAction),
        }),
      },
    },
  };
}

export default function localTrackInternalReducer(
  state = initialState,
  action
) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/localTrackInternalFormData.js